module.exports = __webpack_public_path__ + "img/point_rules.fd517a7e.png";